const global = {
	sb_title: "XL3",
	sb_main_menu: "Main Menu",
	sb_manage_menu: "Manage",
	sb_admin_menu: "Administration",
	sb_template_menu: "Templates",
	sb_more_menu: "More",
	manuals: "Manuals",
	my_profile: "My Profile",
	new: "New",
	edit: "Edit",
	view: "View",
	preview: "Preview",
	preview_not_available: "Preview not available",
	delete: "Delete",
	delete_selected: "Delete selected",
	remove: "Remove",
	save: "Save",
	save_send: "Save and send",
	save_without_notification: "Save without notification",
	notify: "Notify",
	send: "Send",
	cancel: "Cancel",
	back: "Back",
	actions: "Actions",
	copy: "Copy",
	move: "Move",
	copy_to_kursweb: "Copy to Internal Docs",
	copy_to_kompetanse: "Copy to Student's Docs",
	move_to_kursweb: "Move to Internal Docs",
	move_to_kompetanse: "Move to Student's Docs",
	filter: "Filter",
	show_filter: "Show Filter",
	hide_filter: "Hide Filter",
	clear: "Clear",
	reset: "Reset",
	restore: "Restore",
	start: "Start",
	stop: "Stop",
	pdf: "PDF",
	close: "Close",
	merge: "Merge",
	verify: "Verify",
	add: "Add",
	select: "Select",
	select_all: "Select All",
	show_all: "Show All",
	none_select: "None",
	ok: "OK",
	capture: "Capture",
	match_grade: "Match grade",
	from_file: "From File",
	from_digital_signature: "Digital Signature",
	from_camera: "From Camera",
	switchcamera: "Switch Camera",
	upload: "Upload",
	download: "Download",
	search: "Search",
	search_start_here: "Start search here",
	crop_and_upload: "Edit & Upload",
	validate: "Validate",
	export_excel: "Export (XLSX)",
	get_templates: "Get templates",
	import: "Import",
	refresh: "Refresh",
	something_went_wrong: "Something went wrong. Please contact administrator.",
	added_date: "Added date",
	updated_date: "Updated date",
	deleted_date: "Deleted date",
	create_success: "Record successfully created",
	create_failed: "Failed to create new record",
	update_success: "Record successfully updated",
	update_failed: "Failed to update record",
	delete_message: "Are you sure you want to delete?",
	delete_success: "Record successfully deleted",
	delete_failed: "Failed to delete record",
	setting_updated_success: "Setting successfully updated",
	setting_updated_failed: "Setting update failed",
	delete_file_success: "File successfully deleted",
	delete_file_failed: "Failed to delete file",
	copy_file_success: "Documents successfully copied",
	move_file_success: "Documents successfully moved",
	restore_success: "File/Document successfully restored",
	restore_failed: "File/Document failed to restore",
	save_changes: "Would you like to save changes?",
	discard_changes: "Do you want to discard changes?",
	confirm_message: "Confirmation Required",
	redirecting_to: "Redirecting to",
	invalid_short_url: "Invalid short url",
	more: "More",
	copied: "Copied",
	yes: "Yes",
	no: "No",
	welcome: "Welcome",
	view_history: "View history",
	checked: "Checked",
	unchecked: "Unchecked",
	drop_files_here: "Drop your file(s) here",
	no_locale: "Record not available in {locale} language",
	change_locale: "Locale changed",
	change_locale_refresh: "Changing locale needs a page reload.",
	available: "Available",
	not_available: "Not Available",
	helptext_vat: "Valid value is 9 digits",
	helptext_password: "Min. 8 char. containing letters, numbers",
	location: "Location",
	location_admin: "Admin",
	location_local: "Local",
	last_updated_by: "Last updated by:",
	xl3_admin: "XL3 Admin",
	show_more: "Show more",
	show_less: "Show less",
	new_version: "An update is available. Click \"Refresh\"",
	no_permission_title: "Permission Denied",
	no_permission_text: "You do not have permission to access this page",
	error_tenant_inactive: "Tenant inactive",
	not_available_seats: "Number of sits is less then number of students",
	email_already_in_use_by_tenant: "Email already in use.",
	email_already_in_use: "The email is already existing in CERTREG site.",
	form_not_valid: "Changes have not been saved. Please check mandatory fields.",
	loading_text: "Loading records...",
	no_data_text: "No records available",
	no_data_create: "No data found. Press Enter to create",
	no_results_text: "No results found",
	items_per_page_all_text: "All",
	items_per_page_text: "Records per page:",
	page_text: "{0}-{1} of {2}",
	processing: "Processing. Please wait.",
	see_more: "See more",
	dd_modules_calendar: "Calendar",
	dd_modules_users: "Users",
	dd_modules_roles: "Roles",
	dd_modules_permissions: "Permissions",
	dd_modules_organisations: "Organisations",
	dd_modules_courses: "Courses",
	dd_modules_coursetemplates: "Course Templates",
	dd_modules_coursetypegroups: "Course Type Groups",
	dd_modules_coursetypes: "Course Types",
	dd_modules_checklisttemplates: "Checklist Templates",
	dd_modules_tasks: "Tasks",
	dd_modules_drivingtests: "Driving Tests",
	dd_modules_settings: "Settings",
	dd_modules_class: "Class",
	dd_modules_logs: "Logs",
	dd_modules_queues: "Queues",
	dd_modules_addresses: "Addresses",
	dd_modules_persons: "Persons",
	dd_modules_classrooms: "Classrooms",
	dd_modules_certificate: "Certificates",
	dd_modules_enrolments: "Enrolments",
	dd_modules_participants: "Participants",
	dd_modules_attendees: "Attendees",
	dd_modules_moduletemplates: "Module Templates",
	dd_modules_customergroups: "Customer Groups",
	dd_modules_studentgroups: "Student Groups",
	dd_modules_educationprograms: "Education Programs",
	dd_modules_reports: "Reports",
	dd_modules_passports: "API Clients",
	dd_locales_en: "English",
	dd_locales_no: "Norwegian",
	dd_locales_nn: "Nynorsk",
	dd_user_status_inactive: "Inactive",
	dd_user_status_active: "Active",
	dd_user_status_force_change: "Force Change Password",
	dd_course_status_upcoming: "Upcoming",
	dd_course_status_onhold: "On Hold",
	dd_course_status_archived: "Archived",
	dd_course_status_final: "Completed",
	dd_course_status_cancelled: "Cancelled",
	dd_course_status_ongoing: "Ongoing",
	dd_course_quick_filter_my_courses: "My courses",
	dd_course_quick_filter_unassigned: "Unassigned",
	dd_course_quick_filter_all: "All",
	dd_task_status_inactive: "Inactive",
	dd_task_status_active: "Active",
	dd_drivingtest_status_inactive: "Inactive",
	dd_drivingtest_status_available: "Available",
	dd_drivingtest_status_agreed: "Agreed",
	dd_drivingtest_status_archived: "Archived",
	dd_titles_mr: "Mr",
	dd_titles_mrs: "Mrs",
	dd_titles_ms: "Ms",
	dd_course_templates_status_inactive: "Inactive",
	dd_course_templates_status_active: "Active",
	dd_admin_course_templates_filter_new_and_updated: "New and updated",
	dd_admin_course_templates_filter_all: "All templates",
	dd_module_templates_status_inactive: "Inactive",
	dd_module_templates_status_active: "Active",
	dd_admin_module_templates_filter_new_and_updated: "New and updated",
	dd_admin_module_templates_filter_all: "All templates",
	dd_course_templates_type_certified: "Certified Learning",
	dd_course_templates_type_documented: "Documented Learning",
	dd_course_templates_type_undocumented: "Undocumented Learning",
	dd_course_template_types_documented: "Documented",
	dd_course_template_types_certified: "Certified",
	dd_course_template_types_hotwork: "Hot Work",
	dd_course_template_types_instructor_documented: "Instructor Documented",
	dd_course_template_types_controller: "Controller",
	dd_course_template_types_other: "Other",
	dd_course_templates_type_normal: "Normal",
	dd_course_templates_type_long: "Long",
	dd_course_type_groups_status_inactive: "Inactive",
	dd_course_type_groups_status_active: "Active",
	dd_course_type_groups_type_certified: "Certified Learning",
	dd_course_type_groups_type_documented: "Documented Learning",
	dd_course_type_groups_type_undocumented: "Undocumented Learning",
	dd_course_types_status_inactive: "Inactive",
	dd_course_types_status_active: "Active",
	dd_checklisttemplate_checkliststatus_draft: "Draft",
	dd_checklisttemplate_checkliststatus_completed: "Completed",
	dd_checklisttemplate_checkliststatus_archived: "Archived",
	dd_checklisttemplate_checklisttype_service: "Service job",
	dd_checklisttemplate_checklisttype_control: "Control Report",
	dd_checklisttemplate_checklisttype_daily: "Daily Control",
	dd_checklisttemplate_checklisttype_brakomp: "XL3 forms",
	dd_classes_status_inactive: "Inactive",
	dd_classes_status_active: "Active",
	dd_classes_duration_type_min: "Min",
	dd_classes_duration_type_hours: "Hours",
	dd_addresses_status_not_available: "Not Available",
	dd_addresses_status_available: "Available",
	dd_classroom_status_not_available: "Not Available",
	dd_classroom_status_available: "Available",
	dd_moduletemplate_type_joint: "Joint",
	dd_moduletemplate_type_per_course: "Per course type",
	dd_moduletemplate_template_type_certified: "Certified Learning",
	dd_moduletemplate_template_type_documented: "Documented Learning",
	dd_moduletemplate_template_type_undocumented: "Undocumented Learning",
	dd_customer_group_status_inactive: "Inactive",
	dd_customer_group_status_active: "Active",
	dd_education_program_status_inactive: "Inactive",
	dd_education_program_status_active: "Active",
	dd_student_group_status_inactive: "Inactive",
	dd_student_group_status_active: "Active",
	dd_attendees_theory_test_na: "NA",
	dd_attendees_theory_test_passed: "Passed",
	dd_attendees_theory_test_failed: "Failed",
	dd_tennant_sms_service_active: "Active",
	dd_tennant_sms_service_inactive: "Inactive",
	dd_enrolment_status_inactive: "Inactive",
	dd_enrolment_status_active: "Active",
	dd_enrolment_status_did_not_meet: "Did not meet",
	dd_enrolment_status_request: "Request",
	dd_enrolment_status_cancelled: "Cancelled",
	dd_enrolment_list_status_all: "All",
	dd_enrolment_list_status_active: "Active",
	dd_enrolment_list_status_cancelled: "Cancelled",
	dd_enrolment_list_status_requests: "Requests",
	dd_chart_period_filter_last_3months: "Last 3 months",
	dd_chart_period_filter_last_6months: "Last 6 months",
	dd_chart_period_filter_last_12months: "Last 12 months",
	dd_notificationtemplate_type_email: "Email",
	dd_notificationtemplate_type_sms: "SMS",
	dd_inspection_interval_daily: "Daily",
	dd_inspection_interval_weekly: "Weekly",
	dd_inspection_interval_14day: "14 Days",
	dd_inspection_interval_monthly: "Monthly",
	dd_inspection_interval_quarter: "Quarter",
	dd_inspection_interval_semiannual: "Semi-Annual",
	dd_inspection_interval_annual: "Annual",
	dd_select_visibility_no_choice: "No choice",
	dd_select_visibility_expertise: "Show on expertise",
	dd_select_visibility_course_certificate: "Show on course certificate",
	dd_select_visibility_both: "Show on both",
	dd_klarna_checkout_type_personal: "Private only",
	dd_klarna_checkout_type_organisation: "Organisation only",
	dd_klarna_checkout_type_both: "Both",
	dd_course_enrolment_status_enrolled: "Enrolled",
	dd_course_enrolment_status_attending: "Attending",
	dd_course_enrolment_status_completed: "Completed",
	dd_course_enrolment_status_requested: "Request",
	dd_course_enrolment_status_did_not_meet: "Cancelled",
	dd_course_enrolment_status_cancelled: "Did not meet",
	dd_countries_AFG: "Afghanistan",
	dd_countries_ALA: "Aland Islands",
	dd_countries_ALB: "Albania",
	dd_countries_DZA: "Algeria",
	dd_countries_ASM: "American Samoa",
	dd_countries_AND: "Andorra",
	dd_countries_AGO: "Angola",
	dd_countries_AIA: "Anguilla",
	dd_countries_ATA: "Antartica",
	dd_countries_ATG: "Antigua and Barbuda",
	dd_countries_ARG: "Argentina",
	dd_countries_ARM: "Armenia",
	dd_countries_ABW: "Aruba",
	dd_countries_AUS: "Australia",
	dd_countries_AUT: "Austria",
	dd_countries_AZE: "Azerbaijan",
	dd_countries_BHS: "Bahamas",
	dd_countries_BHR: "Bahrain",
	dd_countries_BGD: "Bangladesh",
	dd_countries_BRB: "Barbados",
	dd_countries_BLR: "Belarus",
	dd_countries_BEL: "Belgium",
	dd_countries_BLZ: "Belize",
	dd_countries_BEN: "Benin",
	dd_countries_BMU: "Bermuda",
	dd_countries_BTN: "Bhutan",
	dd_countries_BOL: "Bolivia, Plurinational State of",
	dd_countries_BES: "Bonaire, Sint Eustatius and Saba",
	dd_countries_BIH: "Bosnia and Herzegovina",
	dd_countries_BWA: "Botswana",
	dd_countries_BVT: "Bouvet Island",
	dd_countries_BRA: "Brazil",
	dd_countries_IOT: "British Indian Ocean Territory",
	dd_countries_BRN: "Brunei Darussalam",
	dd_countries_BGR: "Bulgaria",
	dd_countries_BFA: "Burkina Faso",
	dd_countries_BDI: "Burundi",
	dd_countries_KHM: "Cambodia",
	dd_countries_CMR: "Cameroon",
	dd_countries_CAN: "Canada",
	dd_countries_CPV: "Cape Verde",
	dd_countries_CYM: "Cayman Islands",
	dd_countries_CAF: "Central African Republic",
	dd_countries_TCD: "Chad",
	dd_countries_CHL: "Chile",
	dd_countries_CHN: "China",
	dd_countries_CXR: "Christmas Island",
	dd_countries_CCK: "Cocos (Keeling) Islands",
	dd_countries_COL: "Colombia",
	dd_countries_COM: "Comoros",
	dd_countries_COG: "Congo",
	dd_countries_COD: "Congo, the Democratic Republic of the",
	dd_countries_COK: "Cook Islands",
	dd_countries_CRI: "Costa Rica",
	dd_countries_CIV: "Côte d'Ivoire",
	dd_countries_HRV: "Croatia",
	dd_countries_CUB: "Cuba",
	dd_countries_CUW: "Curaçao",
	dd_countries_CYP: "Cyprus",
	dd_countries_CZE: "Czech Republic",
	dd_countries_DNK: "Denmark",
	dd_countries_DJI: "Djibouti",
	dd_countries_DMA: "Dominica",
	dd_countries_DOM: "Dominican Republic",
	dd_countries_ECU: "Ecuador",
	dd_countries_EGY: "Egypt",
	dd_countries_SLV: "El Salvador",
	dd_countries_GNQ: "Equatorial Guinea",
	dd_countries_ERI: "Eritrea",
	dd_countries_EST: "Estonia",
	dd_countries_ETH: "Ethiopia",
	dd_countries_FLK: "Falkland Islands (Malvinas)",
	dd_countries_FRO: "Faroe Islands",
	dd_countries_FJI: "Fiji",
	dd_countries_FIN: "Finland",
	dd_countries_FRA: "France",
	dd_countries_GUF: "French Guiana",
	dd_countries_PYF: "French Polynesia",
	dd_countries_ATF: "French Southern Territories",
	dd_countries_GAB: "Gabon",
	dd_countries_GMB: "Gambia",
	dd_countries_GEO: "Georgia",
	dd_countries_DEU: "Germany",
	dd_countries_GHA: "Ghana",
	dd_countries_GIB: "Gibraltar",
	dd_countries_GRC: "Greece",
	dd_countries_GRL: "Greenland",
	dd_countries_GRD: "Grenada",
	dd_countries_GLP: "Guadeloupe",
	dd_countries_GUM: "Guam",
	dd_countries_GTM: "Guatemala",
	dd_countries_GGY: "Guernsey",
	dd_countries_GIN: "Guinea",
	dd_countries_GNB: "Guinea-Bissau",
	dd_countries_GUY: "Guyana",
	dd_countries_HTI: "Haiti",
	dd_countries_HMD: "Heard Island and McDonald Islands",
	dd_countries_VAT: "Holy See (Vatican City State)",
	dd_countries_HND: "Honduras",
	dd_countries_HKG: "Hong Kong",
	dd_countries_HUN: "Hungary",
	dd_countries_ISL: "Iceland",
	dd_countries_IND: "India",
	dd_countries_IDN: "Indonesia",
	dd_countries_IRN: "Iran, Islamic Republic of",
	dd_countries_IRQ: "Iraq",
	dd_countries_IRL: "Ireland",
	dd_countries_IMN: "Isle of Man",
	dd_countries_ISR: "Israel",
	dd_countries_ITA: "Italy",
	dd_countries_JAM: "Jamaica",
	dd_countries_JPN: "Japan",
	dd_countries_JEY: "Jersey",
	dd_countries_JOR: "Jordan",
	dd_countries_KAZ: "Kazakhstan",
	dd_countries_KEN: "Kenya",
	dd_countries_KIR: "Kiribati",
	dd_countries_PRK: "Korea, Democratic People's Republic of",
	dd_countries_KOR: "Korea, Republic of",
	dd_countries_KWT: "Kuwait",
	dd_countries_KGZ: "Kyrgyzstan",
	dd_countries_LAO: "Lao People's Democratic Republic",
	dd_countries_LVA: "Latvia",
	dd_countries_LBN: "Lebanon",
	dd_countries_LSO: "Lesotho",
	dd_countries_LBR: "Liberia",
	dd_countries_LBY: "Libya",
	dd_countries_LIE: "Liechtenstein",
	dd_countries_LTU: "Lithuania",
	dd_countries_LUX: "Luxembourg",
	dd_countries_MAC: "Macao",
	dd_countries_MKD: "Macedonia, the former Yugoslav Republic of",
	dd_countries_MDG: "Madagascar",
	dd_countries_MWI: "Malawi",
	dd_countries_MYS: "Malaysia",
	dd_countries_MDV: "Maldives",
	dd_countries_MLI: "Mali",
	dd_countries_MLT: "Malta",
	dd_countries_MHL: "Marshall Islands",
	dd_countries_MTQ: "Martinique",
	dd_countries_MRT: "Mauritania",
	dd_countries_MUS: "Mauritius",
	dd_countries_MYT: "Mayotte",
	dd_countries_MEX: "Mexico",
	dd_countries_FSM: "Micronesia, Federated States of",
	dd_countries_MDA: "Moldova, Republic of",
	dd_countries_MCO: "Monaco",
	dd_countries_MNG: "Mongolia",
	dd_countries_MNE: "Montenegro",
	dd_countries_MSR: "Montserrat",
	dd_countries_MAR: "Morocco",
	dd_countries_MOZ: "Mozambique",
	dd_countries_MMR: "Myanmar",
	dd_countries_NAM: "Namibia",
	dd_countries_NRU: "Nauru",
	dd_countries_NPL: "Nepal",
	dd_countries_NLD: "Netherlands",
	dd_countries_NCL: "New Caledonia",
	dd_countries_NZL: "New Zealand",
	dd_countries_NIC: "Nicaragua",
	dd_countries_NER: "Niger",
	dd_countries_NGA: "Nigeria",
	dd_countries_NIU: "Niue",
	dd_countries_NFK: "Norfolk Island",
	dd_countries_MNP: "Northern Mariana Islands",
	dd_countries_NOR: "Norway",
	dd_countries_OMN: "Oman",
	dd_countries_PAK: "Pakistan",
	dd_countries_PLW: "Palau",
	dd_countries_PSE: "Palestinian Territory, Occupied",
	dd_countries_PAN: "Panama",
	dd_countries_PNG: "Papua New Guinea",
	dd_countries_PRY: "Paraguay",
	dd_countries_PER: "Peru",
	dd_countries_PHL: "Philippines",
	dd_countries_PCN: "Pitcairn",
	dd_countries_POL: "Poland",
	dd_countries_PRT: "Portugal",
	dd_countries_PRI: "Puerto Rico",
	dd_countries_QAT: "Qatar",
	dd_countries_REU: "Réunion",
	dd_countries_ROU: "Romania",
	dd_countries_RUS: "Russian Federation",
	dd_countries_RWA: "Rwanda",
	dd_countries_BLM: "Saint Barthélemy",
	dd_countries_SHN: "Saint Helena, Ascension and Tristan da Cunha",
	dd_countries_KNA: "Saint Kitts and Nevis",
	dd_countries_LCA: "Saint Lucia",
	dd_countries_MAF: "Saint Martin (French part)",
	dd_countries_SPM: "Saint Pierre and Miquelon",
	dd_countries_VCT: "Saint Vincent and the Grenadines",
	dd_countries_WSM: "Samoa",
	dd_countries_SMR: "San Marino",
	dd_countries_STP: "Sao Tome and Principe",
	dd_countries_SAU: "Saudi Arabia",
	dd_countries_SEN: "Senegal",
	dd_countries_SRB: "Serbia",
	dd_countries_SYC: "Seychelles",
	dd_countries_SLE: "Sierra Leone",
	dd_countries_SGP: "Singapore",
	dd_countries_SXM: "Sint Maarten (Dutch part)",
	dd_countries_SVK: "Slovakia",
	dd_countries_SVN: "Slovenia",
	dd_countries_SLB: "Solomon Islands",
	dd_countries_SOM: "Somalia",
	dd_countries_ZAF: "South Africa",
	dd_countries_SGS: "South Georgia and the South Sandwich Islands",
	dd_countries_SSD: "South Sudan",
	dd_countries_ESP: "Spain",
	dd_countries_LKA: "Sri Lanka",
	dd_countries_SDN: "Sudan",
	dd_countries_SUR: "Suriname",
	dd_countries_SJM: "Svalbard and Jan Mayen",
	dd_countries_SWZ: "Swaziland",
	dd_countries_SWE: "Sweden",
	dd_countries_CHE: "Switzerland",
	dd_countries_SYR: "Syrian Arab Republic",
	dd_countries_TWN: "Taiwan, Province of China",
	dd_countries_TJK: "Tajikistan",
	dd_countries_TZA: "Tanzania, United Republic of",
	dd_countries_THA: "Thailand",
	dd_countries_TLS: "Timor-Leste",
	dd_countries_TGO: "Togo",
	dd_countries_TKL: "Tokelau",
	dd_countries_TON: "Tonga",
	dd_countries_TTO: "Trinidad and Tobago",
	dd_countries_TUN: "Tunisia",
	dd_countries_TUR: "Turkey",
	dd_countries_TKM: "Turkmenistan",
	dd_countries_TCA: "Turks and Caicos Islands",
	dd_countries_TUV: "Tuvalu",
	dd_countries_UGA: "Uganda",
	dd_countries_UKR: "Ukraine",
	dd_countries_ARE: "United Arab Emirates",
	dd_countries_GBR: "United Kingdom",
	dd_countries_USA: "United States",
	dd_countries_UMI: "United States Minor Outlying Islands",
	dd_countries_URY: "Uruguay",
	dd_countries_UZB: "Uzbekistan",
	dd_countries_VUT: "Vanuatu",
	dd_countries_VEN: "Venezuela, Bolivarian Republic of",
	dd_countries_VNM: "Viet Nam",
	dd_countries_VGB: "Virgin Islands, British",
	dd_countries_VIR: "Virgin Islands, U.S.",
	dd_countries_WLF: "Wallis and Futuna",
	dd_countries_ESH: "Western Sahara",
	dd_countries_YEM: "Yemen",
	dd_countries_ZMB: "Zambia",
	dd_countries_ZWE: "Zimbabwe",
};
export default global;